import { useState , useEffect} from "react";
import Header from "./About/Header";
import NavBar from "../components/NavBar";

import Section1 from "./About/Section1";
import Section2 from "./About/Section2";
import Section3 from "./About/Section3";
import Section4 from "./About/Section4";
import Section5 from "./About/Section5";
import Footer from "../components/Footer";

export default function About() {
   return (
    <>
    <NavBar />
    <Header />
    <Section1 />
    <Section2 />
    <Section3 />
    <Section4 />
    <Section5 />
    <Footer />
    </>
    );
}